import { render, staticRenderFns } from "./StepTwoDoc.vue?vue&type=template&id=8aa11824&scoped=true"
import script from "./StepTwoDoc.vue?vue&type=script&lang=ts"
export * from "./StepTwoDoc.vue?vue&type=script&lang=ts"
import style0 from "./StepTwoDoc.vue?vue&type=style&index=0&id=8aa11824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa11824",
  null
  
)

export default component.exports